export default __webpack_public_path__ + "static/media/BA7.caf9e5f0.jpg";